import Vue from "vue";

Vue.filter("truncate", (value, num) => {
  if (value == null) return;
  if (!num) num = 18;
  if (value && value.length > num) {
    value = value.substring(0, num - 3) + "...";
  }
  return value;
});



// WEBPACK FOOTER //
// ./src/Filters/truncate.js